import Enemy from "../enemy/Enemy";
import Game from "../Game";
import GameCore from "../GameCore";
import BaseBullet from "./BaseBullet";
import BaseWeapon from "./BaseWeapon";
import { BulletGroup } from "./BulletGroup";
import {
  SPRITESHEET_KEYS,
  SPRITESHEET_FRAMES,
} from "../../consts/SPRITESHEETS";

export default class BoomerangBullet extends BaseBullet {
  bouncePositions: never[];
  save_vel_x: number;
  save_vel_y: number;
  lastHitTime: number;
  ScaleTween: Phaser.Tweens.Tween;
  AngleTween: Phaser.Tweens.Tween;
  constructor(
    group: BulletGroup,
    weapon: BaseWeapon,
    indexInWeapon = 0,
    x: number = 0,
    y: number = 0
  ) {
    super(group, weapon, indexInWeapon, "", x, y, SPRITESHEET_KEYS.WEAPONS);
    this.setTexture(
      SPRITESHEET_KEYS.WEAPONS,
      SPRITESHEET_FRAMES.WEAPONS.BOOMERANG
    );
    this.bouncePositions = [];
    this.save_vel_x = 0;
    this.save_vel_y = 0;
    this.lastHitTime = 0;
    this.scene.physics.world.on("worldbounds", this.Bounce, this);
    this.AngleTween = this.scene.tweens.add({
      targets: this,
      angle: 360,
      duration: 1000,
      ease: "Linear",
      repeat: -1,
    });
  }
  OnRecycle() {
    super.OnRecycle();
    this.setTexture(
      SPRITESHEET_KEYS.WEAPONS,
      SPRITESHEET_FRAMES.WEAPONS.BOOMERANG
    );
    const radius = this.width * 0.4;
    this.Body.setCircle(radius);
    this.Body.setOffset(0, 0);

    this.setScale(1.5 * GameCore.PixelScale * this.weapon.PArea);
    this.setBounce(1, 1);
    this.isCullable = false;
    this.setCollideWorldBounds(true, 1, 1);
    this.Body.setBoundsRectangle(Game.Core.Player.WorldBoxCollider);
    this.Body.onWorldBounds = true;
    this.AimForRandomEnemy();
    this.setAngle(360 * Math.random());
    this.lastHitTime = 0;
    if (this.ScaleTween) {
      this.ScaleTween.stop();
    }
    this.ScaleTween = this.scene.tweens.add({
      targets: this,
      scale: 0,
      duration: 500,
      delay: this.weapon.PDuration,
      ease: "Linear",
      onComplete: () => {
        this.DeSpawn();
      },
    });
  }
  Bounce(body) {
    if (this.body === body) {
      this.objectsHit = [];
    }
  }
  OnHasHitAnObject(enemy: Enemy) {
    const currentTime = this.scene.time.now;
    if (!enemy.isDead && this.body && currentTime - this.lastHitTime > 100) {
      this.lastHitTime = currentTime;

      const reflectionFactor = 1.15;
      const vx = -1 * this.body.velocity.x * reflectionFactor;
      const vy = -1 * this.body.velocity.y * reflectionFactor;

      const angle = Math.atan2(vy, vx);
      const offsetX = Math.cos(angle) * 10;
      const offsetY = Math.sin(angle) * 10;
      this.x += offsetX;
      this.y += offsetY;

      const speed = Math.sqrt(vx * vx + vy * vy);
      const maxSpeed = this.TrueSpeed * 1.5;
      const minSpeed = this.TrueSpeed * 0.8;

      if (speed > maxSpeed) {
        const scaleFactor = maxSpeed / speed;
        this.setVelocity(vx * scaleFactor, vy * scaleFactor);
      } else if (speed < minSpeed) {
        const scaleFactor = minSpeed / speed;
        this.setVelocity(vx * scaleFactor, vy * scaleFactor);
      } else {
        this.setVelocity(vx, vy);
      }

      this.objectsHit = [];
    }
  }
  // OnHasHitWall(enemy: Enemy) {
  //   // this.save_vel_x *=  1
  //   // this.save_vel_y *=  1
  //   console.log('onHasHitWall')
  //   this.setVelocity(this.save_vel_x, this.save_vel_y)
  //   this.objectsHit = []
  // }
  Update() {
    if (this.body) {
      const minVelocity = 50;
      const currentVelX = this.body.velocity.x;
      const currentVelY = this.body.velocity.y;

      if (Math.abs(currentVelX) > minVelocity) {
        this.save_vel_x = currentVelX;
      }

      if (Math.abs(currentVelY) > minVelocity) {
        this.save_vel_y = currentVelY;
      }

      if (
        Math.abs(currentVelX) < minVelocity &&
        Math.abs(currentVelY) < minVelocity
      ) {
        const restoredVelX = this.save_vel_x || 100;
        const restoredVelY = this.save_vel_y || 100;
        this.setVelocity(restoredVelX, restoredVelY);
      }
    }
  }
  DeSpawn() {
    this.isCullable = true;
    // Game.Core.scene.time.removeEvent(this.ExpireTimer)
    super.DeSpawn();
  }
}
